import React from 'react';
export function ProofStrip() {
  return <div className="bg-sky border-t-[3px] border-gold border-b border-border py-4 md:py-5 px-5 text-center" data-id="element-202">
      <div className="flex justify-center gap-6 md:gap-10 flex-wrap max-w-[1080px] mx-auto" data-id="element-203">
        <div className="text-center" data-id="element-204">
          <strong className="block font-display text-[28px] md:text-[32px] text-blue tracking-wide" data-id="element-205">
            +800
          </strong>
          <span className="text-[11px] md:text-[12px] text-text-muted font-semibold tracking-wider uppercase" data-id="element-206">
            Ciudadanos protegidos
          </span>
        </div>
        <div className="text-center" data-id="element-207">
          <strong className="block font-display text-[28px] md:text-[32px] text-blue tracking-wide" data-id="element-208">
            4.9
          </strong>
          <span className="text-[11px] md:text-[12px] text-text-muted font-semibold tracking-wider uppercase" data-id="element-209">
            Rating promedio
          </span>
        </div>
        <div className="text-center" data-id="element-210">
          <strong className="block font-display text-[28px] md:text-[32px] text-blue tracking-wide" data-id="element-211">
            8
          </strong>
          <span className="text-[11px] md:text-[12px] text-text-muted font-semibold tracking-wider uppercase" data-id="element-212">
            Tomos de acción
          </span>
        </div>
        <div className="text-center" data-id="element-213">
          <strong className="block font-display text-[28px] md:text-[32px] text-blue tracking-wide" data-id="element-214">
            4
          </strong>
          <span className="text-[11px] md:text-[12px] text-text-muted font-semibold tracking-wider uppercase" data-id="element-215">
            Bonos incluidos
          </span>
        </div>
        <div className="text-center" data-id="element-216">
          <strong className="block font-display text-[28px] md:text-[32px] text-blue tracking-wide" data-id="element-217">
            Todo
          </strong>
          <span className="text-[11px] md:text-[12px] text-text-muted font-semibold tracking-wider uppercase" data-id="element-218">
            Argentina
          </span>
        </div>
      </div>
    </div>;
}